export default "static/media/pill-aid.56319ad.svg"